import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

/**
 * Unwraps the Fannie Mae Chassis API envelope so services can type their
 * responses as plain payloads (array or object) instead of the wrapper shape:
 *
 *   { correlationId, status, message, timestamp, responsePayload: <actual data> }
 *
 * Only /api/* responses that are HttpResponse<object> are unwrapped.
 * Non-API calls, binary responses, and non-object responses pass through unchanged.
 */
export const chassisResponseInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith('/api')) {
    return next(request);
  }

  return next(request).pipe(
    map((event) => {
      if (
        event instanceof HttpResponse &&
        event.body !== null &&
        typeof event.body === 'object' &&
        'responsePayload' in (event.body as object)
      ) {
        return event.clone({ body: (event.body as { responsePayload: unknown }).responsePayload });
      }
      return event;
    })
  );
};
